
import ManufacturerService from './ManufacturerService';

export { default } from './ManufacturerService';
export const manufacturerService = new ManufacturerService();